var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.HasScale
      ? _c("div", [
          _c(
            "div",
            { staticClass: "list-group" },
            _vm._l(_vm.ScaleLevels, function (sl) {
              return _c(
                "button",
                {
                  staticClass:
                    "list-group-item list-group-item-action text-left",
                  class: { active: _vm.isSelected(sl) },
                  on: {
                    click: function ($event) {
                      return _vm.setScaleValue(sl)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa",
                    class: [
                      _vm.isSelected(sl) ? "fa-check-circle" : "fa-circle-thin",
                    ],
                  }),
                  _vm._v(
                    " " +
                      _vm._s(sl.Name) +
                      " (" +
                      _vm._s(sl.Value) +
                      ")\n\n            "
                  ),
                  sl.Definition
                    ? _c("p", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(sl.Definition)),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("textarea", {
            staticClass: "form-control my-3",
            attrs: { rows: "3", placeholder: "Comment..." },
            domProps: { value: _vm.Comment },
            on: {
              input: function ($event) {
                return _vm.setComment($event.target.value)
              },
            },
          }),
          _vm._v(" "),
          !_vm.HasAnswer
            ? _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setComment("Skipped")
                    },
                  },
                },
                [_vm._v("\n            Skip (don't guess)\n        ")]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.HasScale
      ? _c("div", [
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "number" },
            domProps: { value: _vm.Value },
            on: {
              input: function ($event) {
                return _vm.setDirectValue($event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("textarea", {
            staticClass: "form-control my-3",
            attrs: { rows: "3", placeholder: "Comment..." },
            domProps: { value: _vm.Comment },
            on: {
              input: function ($event) {
                return _vm.setComment($event.target.value)
              },
            },
          }),
          _vm._v(" "),
          !_vm.HasAnswer
            ? _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setComment("Skipped")
                    },
                  },
                },
                [_vm._v("\n            Skip (don't guess)\n        ")]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }